import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl";
import { Modal, ModalHeader, ModalFooter, Button, Form, InputGroup, FormControl } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import Swal from "sweetalert2";
import {
    useReactTable,
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    flexRender,
} from "@tanstack/react-table";

function Programs({ refresh }) {
    const [data, setData] = useState([]);
    const [roles, setRoles] = useState([]);
    const [selectedRole, setSelectedRole] = useState("");
    const [showModal, setShowModal] = useState(false);
    const accesstoken = localStorage.getItem("token");
    const navigate = useNavigate();
    const [checkedItems, setCheckedItems] = useState({});
    const accessuserid = localStorage.getItem("id");
    const [programs, setPrograms] = useState([]);
    const [loading, setLoading] = useState(true);

    const [editshowModal, seteditshowModal] = useState(false);
    const [pgmId, setpgmId] = useState("");

    const [edselectedRole, setedSelectedRole] = useState("");
    const [edSelectedRolename, setedSelectedRolename] = useState("");
    const [refreshSidebar, setRefreshSidebar] = useState(false);

    // TanStack Table state
    const [sorting, setSorting] = useState([]);
    const [globalFilter, setGlobalFilter] = useState("");

    const handleRefreshSidebar = () => {
        setRefreshSidebar(prev => !prev);
    };

    // FIXED: Clear state when opening Add modal
    const handleclick = () => {
        setShowModal(true);
        setCheckedItems({}); // Clear previous checkbox selections
        setSelectedRole(""); // Clear selected role
        GetAllmenu();
    };

    // Fetch roles 
    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const res = await axios.get(
                    `${baseurladdress}users/findallroles`,
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`,
                        },
                    }
                );

                if (res.data.status === "Success") {
                    setRoles(res.data.roles);
                } else {
                    setRoles([]);
                }
            } catch (error) {
                console.error(error);
                alert("Failed to fetch roles.");
            }
        };

        fetchRoles();
    }, []);

    const GetAllmenu = async () => {
        try {
            const response = await axios.get(`${baseurladdress}prog/getprogramtree`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            });

            if (response.data.status === "Success" && response.data.programs.length > 0) {
                console.log("Program Tree:", response.data.programs);
                setData(response.data.programs);
            } else {
                console.log("No programs found");
                setData([]);
            }
        } catch (error) {
            console.error("Failed to fetch menu tree:", error);
            setData([]);
            alert("Failed to fetch menu tree.");
        }
    };

    function chunkArray(arr, size) {
        const result = [];
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, i + size));
        }
        return result;
    }

    const handleCheckboxChange = (pgmId, isChecked, isParent = false) => {
        const newCheckedItems = { ...checkedItems, [pgmId]: isChecked };
        if (isParent) {
            data.forEach((item) => {
                if (item.pgm_parent === pgmId) {
                    newCheckedItems[item.pgm_id] = isChecked;
                }
            });
        }
        setCheckedItems(newCheckedItems);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const selectedProgramIds = Object.keys(checkedItems).filter((key) => checkedItems[key]);

        if (!selectedRole) {
            alert("Please select a role");
            return;
        }

        if (selectedProgramIds.length === 0) {
            alert("Please select at least one program");
            return;
        }

        const selectedProgramNames = selectedProgramIds
            .map((id) => {
                const match = data.find((item) => item.pgm_id.toString() === id.toString());
                return match ? match.pgm_menu : null;
            })
            .filter(Boolean);

        const payload = {
            userpgm_pgm: selectedRole,
            userpgm_programs: selectedProgramIds.join(","),
            userpgm_program_names: selectedProgramNames.join(","),
            userpgm_crtdby: accessuserid,
        };

        console.log("Sending payload:", payload);

        try {
            const response = await axios.post(baseurladdress + "prog/addprogram", payload, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            });

            if (response.data.status === "success") {
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Programs added successfully",
                    showConfirmButton: false,
                    timer: 2500,
                });

                handleRefreshSidebar();
                setSelectedRole("");
                setCheckedItems({});
                setShowModal(false);
                fetchPrograms();

            } else if (response.data.status === "exists") {
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "warning",
                    title: "Programs already exist for this role",
                    showConfirmButton: false,
                    timer: 2500,
                });
            } else {
                alert("Failed to save program access. " + (response.data.message || ""));
            }
        } catch (error) {
            console.error("Save error:", error);
            alert("An error occurred while saving.");
        }
    };

    const fetchPrograms = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            console.log("Fetching programs..."); // Debug log

            const response = await axios.get(baseurladdress + `prog/findallprogram`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            console.log("Programs response:", response.data); // Debug log

            if (response.data.status === "Success" && response.data.programs.length > 0) {
                setPrograms(response.data.programs);
            } else {
                setPrograms([]);
                console.error("No programs found");
            }
        } catch (err) {
            console.error("Error fetching programs", err);
            setPrograms([]);
        } finally {
            setLoading(false);
        }
    };

    // Fetch programs on mount and when refresh changes
    useEffect(() => {
        fetchPrograms();
    }, [refresh]);

    const handleeditclick = async (pgmId) => {
        seteditshowModal(true);
        setpgmId(pgmId);
        setCheckedItems({}); // Clear previous selections before loading new ones

        // Fetch the full menu/tree
        GetAllmenu();

        try {
            const res = await axios.get(`${baseurladdress}prog/editpgm/${pgmId}`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            });

            if (res.data.status === "Success" && res.data.program) {
                const data = res.data.program;

                setedSelectedRole(data.userpgm_pgm);

                // Pre-check checkboxes
                const selectedProgramIds = data.userpgm_programs
                    ? data.userpgm_programs.split(",")
                    : [];
                const checked = {};
                selectedProgramIds.forEach((id) => {
                    checked[id] = true;
                });
                setCheckedItems(checked);
            } else {
                alert("Program not found for editing");
                setCheckedItems({});
            }
        } catch (error) {
            alert("Failed to fetch program data for editing");
            console.error(error);
            setCheckedItems({});
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();

        // Get selected program IDs
        const selectedProgramIds = Object.keys(checkedItems).filter((key) => checkedItems[key]);

        if (!edselectedRole) {
            alert("Please select a role");
            return;
        }

        if (selectedProgramIds.length === 0) {
            alert("Please select at least one program");
            return;
        }

        // Map program IDs to names
        const selectedProgramNames = selectedProgramIds
            .map((id) => {
                const match = data.find((item) => item.pgm_id.toString() === id.toString());
                return match ? match.pgm_menu : null;
            })
            .filter(Boolean);

        // Prepare payload
        const payload = {
            userpgm_id: pgmId,
            userpgm_pgm: edselectedRole,
            userpgm_programs: selectedProgramIds.join(","),
            userpgm_program_names: selectedProgramNames.join(","),
            userpgm_updby: accessuserid,
        };

        console.log("Updating payload:", payload);

        try {
            const res = await axios.post(baseurladdress + "prog/updateprogram", payload, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            });

            if (res.data.status === "success") {
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Programs updated successfully",
                    showConfirmButton: false,
                    timer: 2500,
                });

                handleRefreshSidebar();
                seteditshowModal(false);
                setCheckedItems({});
                setedSelectedRole("");
                fetchPrograms();

            } else if (res.data.status === "Not Found") {
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "warning",
                    title: res.data.message || "Program record not found",
                    showConfirmButton: false,
                    timer: 2500,
                });
            } else {
                alert("Update failed. " + (res.data.message || ""));
            }

        } catch (error) {
            console.error("Update error:", error);
            alert("An error occurred while updating.");
        }
    };

    const handleDelete = async (pgmId) => {
        const confirmResult = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085D6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        });

        if (!confirmResult.isConfirmed) return;

        try {
            const response = await axios.post(
                `${baseurladdress}prog/deleteprogram/${pgmId}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            if (response.data.status === "deleted") {
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Program deleted successfully",
                    showConfirmButton: false,
                    timer: 2500,
                });
                fetchPrograms();
            } else if (response.data.status === "Not Found") {
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "warning",
                    title: response.data.message || "Program not found",
                    showConfirmButton: false,
                    timer: 2500,
                });
            } else {
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "error",
                    title: "Failed to delete program",
                    showConfirmButton: false,
                    timer: 2500,
                });
            }
        } catch (error) {
            console.error("Delete error:", error);
            Swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: "An error occurred while deleting",
                showConfirmButton: false,
                timer: 2500,
            });
        }
    };


    // FIXED: Close handler for Add modal
    const handleCloseAddModal = () => {
        setShowModal(false);
        setCheckedItems({});
        setSelectedRole("");
        document.activeElement.blur();
    };

    // FIXED: Close handler for Edit modal
    const handleCloseEditModal = () => {
        seteditshowModal(false);
        setCheckedItems({});
        setedSelectedRole("");
        document.activeElement.blur();
    };

    // Define columns for TanStack Table
    const columns = useMemo(
        () => [
            {
                accessorKey: "index",
                header: "Sl.No",
                size: 60,
                cell: ({ row }) => row.index + 1,
            },
            {
                accessorKey: "role_name",
                header: "Role Name",
                size: 150,
            },
            {
                accessorKey: "userpgm_status",
                header: "Status",
                size: 100,
                cell: ({ row }) => (
                    <div>
                        {row.original.userpgm_status == 0 ? (
                            <span className="badge bg-danger">Inactive</span>
                        ) : (
                            <span className="badge bg-success">Active</span>
                        )}
                    </div>
                ),
            },
            {
                accessorKey: "actions",
                header: "Actions",
                enableSorting: false,
                cell: ({ row }) => (
                    <div className="d-flex gap-2">
                        <Icon.PencilSquare
                            className="text-primary"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleeditclick(row.original.userpgm_id)}
                        />
                        <Icon.Trash
                            className="text-danger"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleDelete(row.original.userpgm_id)}
                        />
                    </div>
                ),
                size: 80,
            },
        ],
        []
    );

    // Create table instance
    const table = useReactTable({
        data: programs,
        columns,
        state: {
            sorting,
            globalFilter,
        },
        onSortingChange: setSorting,
        onGlobalFilterChange: setGlobalFilter,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        initialState: {
            pagination: {
                pageSize: 10,
            },
        },
    });

    return (
        <div>
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">

                        <div className="card">
                            <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center py-3">
                                <h6 className="card-title">PROGRAM DETAILS</h6>
                                <div className="d-flex align-items-center">
                                    <Button
                                        variant="light"
                                        size="sm"
                                        onClick={(e) => {
                                            handleclick();
                                            e.currentTarget.blur();
                                        }}
                                        className="d-flex align-items-center"
                                    >
                                        <Icon.Plus className="me-1" />
                                        Add
                                    </Button>
                                </div>
                            </div>
                            <div className="card-body">
                                {/* Page Size and Search Controls */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="text-muted small">Show</span>
                                        <Form.Select
                                            size="sm"
                                            style={{ width: "70px" }}
                                            value={table.getState().pagination.pageSize}
                                            onChange={(e) => {
                                                table.setPageSize(Number(e.target.value));
                                            }}
                                        >
                                            {[5, 10, 20, 50].map((pageSize) => (
                                                <option key={pageSize} value={pageSize}>
                                                    {pageSize}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <span className="text-muted small">entries</span>
                                    </div>

                                    <InputGroup style={{ width: "250px" }}>
                                        <InputGroup.Text>
                                            <Icon.Search size={14} />
                                        </InputGroup.Text>
                                        <FormControl
                                            size="sm"
                                            placeholder="Search..."
                                            value={globalFilter ?? ""}
                                            onChange={(e) => setGlobalFilter(e.target.value)}
                                        />
                                    </InputGroup>
                                </div>

                                {/* Table */}
                                <div className="table-responsive">
                                    <table className="table table-hover table-sm align-middle">
                                        <thead className="table-light">
                                            {table.getHeaderGroups().map((headerGroup) => (
                                                <tr key={headerGroup.id}>
                                                    {headerGroup.headers.map((header) => (
                                                        <th
                                                            key={header.id}
                                                            style={{ width: header.getSize() }}
                                                            className="text-nowrap"
                                                        >
                                                            {header.isPlaceholder ? null : (
                                                                <div
                                                                    {...{
                                                                        className: header.column.getCanSort()
                                                                            ? "cursor-pointer select-none d-flex align-items-center"
                                                                            : "",
                                                                        onClick: header.column.getToggleSortingHandler(),
                                                                    }}
                                                                >
                                                                    {flexRender(
                                                                        header.column.columnDef.header,
                                                                        header.getContext()
                                                                    )}
                                                                    {header.column.getCanSort() && (
                                                                        <span className="ms-1">
                                                                            {{
                                                                                asc: <Icon.ChevronUp size={12} />,
                                                                                desc: <Icon.ChevronDown size={12} />,
                                                                            }[header.column.getIsSorted()] ?? (
                                                                                    <Icon.ChevronExpand size={12} className="text-muted" />
                                                                                )}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </th>
                                                    ))}
                                                </tr>
                                            ))}
                                        </thead>
                                        <tbody>
                                            {table.getRowModel().rows.length > 0 ? (
                                                table.getRowModel().rows.map((row) => (
                                                    <tr key={row.id}>
                                                        {row.getVisibleCells().map((cell) => (
                                                            <td
                                                                key={cell.id}
                                                                style={{
                                                                    textAlign: "left",
                                                                    verticalAlign: "middle",
                                                                }}
                                                            >
                                                                {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={columns.length} className="text-center text-muted py-4">
                                                        {loading ? "Loading..." : "No programs found"}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Compact Pagination */}
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <div className="text-muted small">
                                        Showing {table.getState().pagination.pageIndex * table.getState().pagination.pageSize + 1} to{" "}
                                        {Math.min(
                                            (table.getState().pagination.pageIndex + 1) * table.getState().pagination.pageSize,
                                            table.getFilteredRowModel().rows.length
                                        )}{" "}
                                        of {table.getFilteredRowModel().rows.length} entries
                                    </div>

                                    <div className="btn-group btn-group-sm">
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => table.setPageIndex(0)}
                                            disabled={!table.getCanPreviousPage()}
                                        >
                                            <Icon.ChevronDoubleLeft size={14} />
                                        </Button>
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => table.previousPage()}
                                            disabled={!table.getCanPreviousPage()}
                                        >
                                            <Icon.ChevronLeft size={14} />
                                        </Button>
                                        <Button variant="outline-secondary" disabled>
                                            Page {table.getState().pagination.pageIndex + 1} of {table.getPageCount()}
                                        </Button>
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => table.nextPage()}
                                            disabled={!table.getCanNextPage()}
                                        >
                                            <Icon.ChevronRight size={14} />
                                        </Button>
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                                            disabled={!table.getCanNextPage()}
                                        >
                                            <Icon.ChevronDoubleRight size={14} />
                                        </Button>
                                    </div>
                                </div>
                            </div>

                            {/* Add Modal */}
                            <Modal
                                className="modal-size md modal-top-center"
                                show={showModal}
                                centered
                                style={{ display: "flex" }}
                                onHide={handleCloseAddModal}
                                backdrop="static"
                                keyboard={false}
                            >
                                <Modal.Header>
                                    <h6>ADD PROGRAMS</h6>
                                    <span
                                        aria-hidden="true"
                                        style={{ cursor: "pointer" }}
                                        onClick={handleCloseAddModal}
                                    >
                                        ×
                                    </span>
                                </Modal.Header>

                                <Modal.Body className="css">
                                    <form onSubmit={(e) => e.preventDefault()}>
                                        <div className="row">
                                            {/* Role Selection */}
                                            <div className="col-md-12 mt-2">
                                                <h6>Role Name</h6>
                                                <select
                                                    className="form-control select"
                                                    name="role"
                                                    value={selectedRole}
                                                    onChange={(e) => setSelectedRole(e.target.value)}
                                                    required
                                                >
                                                    <option value="" disabled>
                                                        Select
                                                    </option>
                                                    {roles.map((item) => (
                                                        <option key={item.role_id} value={item.role_id}>
                                                            {item.role_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Program Tree Display */}
                                            {data.length > 0 && (
                                                <div className="mt-4 col-md-12">
                                                    <h6>Program Menus</h6>
                                                    <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                                                        {data
                                                            .filter((item) => item.seq.split("_").length - 1 === 0)
                                                            .map((parent) => (
                                                                <li key={parent.pgm_id} style={{ fontWeight: "bold", color: "blue" }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={checkedItems[parent.pgm_id] || false}
                                                                        onChange={(e) =>
                                                                            handleCheckboxChange(parent.pgm_id, e.target.checked, true)
                                                                        }
                                                                        style={{ marginRight: "0.5rem" }}
                                                                        value={parent.pgm_id}
                                                                        name="myArray[]"
                                                                    />
                                                                    <span>{parent.pgm_menu}</span>

                                                                    {/* Depth 1 children */}
                                                                    <div className="ml-4 mt-2">
                                                                        {chunkArray(
                                                                            data.filter(
                                                                                (item) =>
                                                                                    item.pgm_parent === parent.pgm_id &&
                                                                                    item.seq.split("_").length - 1 === 1
                                                                            ),
                                                                            2
                                                                        ).map((row, rowIndex) => (
                                                                            <div className="d-flex" key={rowIndex}>
                                                                                {row.map((child) => (
                                                                                    <div
                                                                                        key={child.pgm_id}
                                                                                        className="d-flex align-items-center"
                                                                                        style={{
                                                                                            flex: 1,
                                                                                            paddingLeft: "2rem",
                                                                                            color: "purple",
                                                                                            textTransform: "capitalize",
                                                                                        }}
                                                                                    >
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={checkedItems[child.pgm_id] || false}
                                                                                            onChange={(e) =>
                                                                                                handleCheckboxChange(child.pgm_id, e.target.checked)
                                                                                            }
                                                                                            style={{ marginRight: "0.5rem" }}
                                                                                            value={child.pgm_id}
                                                                                            name="myArray[]"
                                                                                        />
                                                                                        <span>{child.pgm_menu}</span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </li>
                                                            ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </form>
                                </Modal.Body>

                                <Modal.Footer>
                                    <button
                                        className="btn btn-primary"
                                        type="button"
                                        onClick={handleSubmit}
                                    >
                                        SAVE
                                    </button>
                                </Modal.Footer>
                            </Modal>

                            {/* Edit Modal */}
                            <Modal
                                className="modal-size md modal-top-center"
                                show={editshowModal}
                                centered
                                style={{ display: "flex" }}
                                onHide={handleCloseEditModal}
                                backdrop="static"
                                keyboard={false}
                            >
                                <Modal.Header>
                                    <h6>EDIT PROGRAMS</h6>
                                    <span
                                        aria-hidden="true"
                                        style={{ cursor: "pointer" }}
                                        onClick={handleCloseEditModal}
                                    >
                                        ×
                                    </span>
                                </Modal.Header>

                                <Modal.Body className="css">
                                    <form onSubmit={(e) => e.preventDefault()}>
                                        <div className="row">
                                            {/* Role Selection */}
                                            <div className="col-md-12 mt-2">
                                                <h6>Role Name</h6>
                                                <select
                                                    className="form-control select"
                                                    name="role"
                                                    value={edselectedRole}
                                                    onChange={(e) => {
                                                        const selectedId = e.target.value;
                                                        const selectedItem = roles.find(item => item.role_id == selectedId);
                                                        setedSelectedRole(selectedId);
                                                        setedSelectedRolename(selectedItem ? selectedItem.role_name : "");
                                                    }}
                                                    required
                                                >
                                                    <option value="" disabled>Select</option>
                                                    {roles.map((item) => (
                                                        <option key={item.role_id} value={item.role_id}>
                                                            {item.role_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Program Tree Display */}
                                            {data.length > 0 && (
                                                <div className="mt-4 col-md-12">
                                                    <h6>Program Menus</h6>
                                                    <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                                                        {data
                                                            .filter((item) => item.seq.split("_").length - 1 === 0)
                                                            .map((parent) => (
                                                                <li key={parent.pgm_id} style={{ fontWeight: "bold", color: "blue" }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={checkedItems[parent.pgm_id] || false}
                                                                        onChange={(e) =>
                                                                            handleCheckboxChange(parent.pgm_id, e.target.checked, true)
                                                                        }
                                                                        style={{ marginRight: "0.5rem" }}
                                                                        value={parent.pgm_id}
                                                                        name="myArray[]"
                                                                    />
                                                                    <span>{parent.pgm_menu}</span>

                                                                    {/* Level 1 children */}
                                                                    <div className="ml-4 mt-2">
                                                                        {chunkArray(
                                                                            data.filter(
                                                                                (item) =>
                                                                                    item.pgm_parent === parent.pgm_id &&
                                                                                    item.seq.split("_").length - 1 === 1
                                                                            ),
                                                                            2
                                                                        ).map((row, rowIndex) => (
                                                                            <div className="d-flex" key={rowIndex}>
                                                                                {row.map((child) => (
                                                                                    <div
                                                                                        key={child.pgm_id}
                                                                                        className="d-flex align-items-center"
                                                                                        style={{
                                                                                            flex: 1,
                                                                                            paddingLeft: "2rem",
                                                                                            color: "purple",
                                                                                            textTransform: "capitalize",
                                                                                        }}
                                                                                    >
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={checkedItems[child.pgm_id] || false}
                                                                                            onChange={(e) =>
                                                                                                handleCheckboxChange(child.pgm_id, e.target.checked)
                                                                                            }
                                                                                            style={{ marginRight: "0.5rem" }}
                                                                                            value={child.pgm_id}
                                                                                            name="myArray[]"
                                                                                        />
                                                                                        <span>{child.pgm_menu}</span>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </li>
                                                            ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </form>
                                </Modal.Body>

                                <Modal.Footer>
                                    <button
                                        className="btn btn-primary"
                                        type="button"
                                        onClick={handleUpdate}
                                    >
                                        UPDATE
                                    </button>
                                </Modal.Footer>
                            </Modal>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default Programs;